module.exports = __webpack_public_path__ + "img/book-open.e8c7fe4e.svg";